import { PrimaryModelsClient } from "./client";
import { getPrimaryDatabaseUrl } from "./connection-url";
import { enableQueryLogging } from "./query-logger";


const LOG_PRISMA_QUERIES = process.env["LOG_PRISMA_QUERIES"] === "true";

export const PrimaryModelsProvider = {
  provide: PrimaryModelsClient,
  useFactory: async () => {

    const datasources = { db: { url: getPrimaryDatabaseUrl() } };

    const client = LOG_PRISMA_QUERIES ? new PrimaryModelsClient({
      datasources,
      log: [
        {
          emit: "event",
          level: "query",
        },
      ],
    }) : new PrimaryModelsClient({ datasources });

    if (LOG_PRISMA_QUERIES) {
      enableQueryLogging(client, 0);
    }

    await client.$connect();
    return client;
  },
};
